export default __webpack_public_path__ + "static/media/home-creative-agency-testimonials-bg.f38895eb.jpg";